import React from 'react';
import { cn } from '../../lib/cn';

// Small label/value pill used in page headers and footer snapshot bars.
export default function StatPill({ icon: Icon, label, value, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 h-7 px-3 rounded-full bg-white/10 border border-white/15 text-[12px] text-white/90 backdrop-blur',
        className
      )}
    >
      {Icon ? <Icon className="h-3.5 w-3.5 opacity-80" /> : null}
      {label ? <span className="text-white/60">{label}</span> : null}
      <span className="font-semibold tabular-nums">{value}</span>
    </span>
  );
}
